import { ProductViewConfigurator } from '~/types/configurator';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'shape',
            keyLabel: 'shape',
            label: 'Shape',
            ignoreForFilter: true,
            displayAsImages: false,
            choices: [
                {
                    value: 'custom',
                    label: 'Custom',
                },
                {
                    value: 'circle-or-oval',
                    label: 'Circle or oval',
                },
                {
                    value: 'square-or-rectangle',
                    label: 'Square or rectangle',
                },
            ],
        },
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'White'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-white.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'standard',
                    description: (description =
                        'A traditional bright white material that lets your colors pop and your brand shine. Offered with a matte or gloss finish.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Metallic'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-metal.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'metallic',
                    description: (description =
                        'This material allows metallic effects to shine in any area not covered by a layer of white ink. Offered with a matte or gloss finish.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Material options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                {
                    label: (label = 'Matte'),
                    detailsModalLabel: label,
                    value: 'matte',
                    description: (description =
                        'If you prefer a more satin finish with a softer touch, we suggest matte. A more sophisticated look for your brand.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Gloss'),
                    detailsModalLabel: label,
                    value: 'gloss',
                    description: (description =
                        'Gloss is a bright, shiny finish for an extra boost to make your colors really pop.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Finish options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                { label: '2” × 2”', value: '2-x-2' },
                { label: '2.5” × 2.5”', value: '2.5-x-2.5' },
                { label: '2.5” × 4”', value: '2.5-x-4' },
                { label: '3” × 3”', value: '3-x-3' },
                { label: '3.5” × 3.5”', value: '3.5-x-3.5' },
                { label: '4” × 4”', value: '4-x-4' },
                { label: '5” × 5”', value: '5-x-5' },
                { label: '6” × 6”', value: '6-x-6' },
                //{ label: 'Custom', value: 'custom' },
            ],
            modalComponent: 'StickerSizeModal',
        },
    ],
} as ProductViewConfigurator;
